import * as actionTypes from '../Global_action.types';

const initialState = {
  loggingIn: false,
  roles: [],
  error: null,
  message: '',
};

const roleReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ROLE_CREATE_REQUEST:
    case actionTypes.ROLE_GET_REQUEST:
    case actionTypes.ROLE_UPDATE_REQUEST:
    case actionTypes.ROLE_DELETE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.ROLE_CREATE_SUCCESS:
    case actionTypes.ROLE_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        roles: action.payload,
      }
    case actionTypes.ROLE_UPDATE_SUCCESS:
    case actionTypes.ROLE_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
      };

    case actionTypes.ROLE_CREATE_FAILURE:
    case actionTypes.ROLE_GET_FAILURE:
    case actionTypes.ROLE_UPDATE_FAILURE:
    case actionTypes.ROLE_DELETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default roleReducer
